import React, { useState } from 'react'
import { User } from 'Generated/graphql-types'
import { AssignTaskOwner } from '../../../Dashboard/NonprofitPlatformDashboard/TaskList/AssignTaskOwner'

type TaskOwnerProps = {
  onChangeTaskOwner: (newOwner: number) => void
  owner: User | null
}

export const TaskOwner = ({ onChangeTaskOwner, owner }: TaskOwnerProps) => {
  const [isTaskOwnerPopoverOpen, setIsTaskOwnerPopoverOpen] = useState(false)
  const [academyLinksAnchorEl, setAcademyLinksAnchorEl] = useState<
    (EventTarget & HTMLElement) | null
  >(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAcademyLinksAnchorEl(event.currentTarget)
    setIsTaskOwnerPopoverOpen(true)
  }

  const handlePopoverClose = () => {
    setAcademyLinksAnchorEl(null)
    setIsTaskOwnerPopoverOpen(false)
  }

  const handleChangeOwner = async (newOwner: number) => {
    if (newOwner === 0) {
      // setOwner(null)
      onChangeTaskOwner(0)
      setIsTaskOwnerPopoverOpen(false)
    }

    if (newOwner) {
      setIsTaskOwnerPopoverOpen(false)
      // setOwner(selectedOwner)
      onChangeTaskOwner(newOwner)
    }

    handlePopoverClose()
  }

  return (
    <AssignTaskOwner
      disabled={false}
      isPopoverOpen={isTaskOwnerPopoverOpen}
      onAssignOwner={handleChangeOwner}
      onClickOwnerAvatar={handlePopoverOpen}
      onClosePopover={handlePopoverClose}
      owner={owner || null}
      popoverAnchorEl={academyLinksAnchorEl}
    />
  )
}
